import { createContext } from "preact";

export type TimerType = {
  activeTimeInMilliseconds: number;
  setActiveTimeInMilliseconds: (n: number) => void;
};

const TimerContext = createContext<TimerType>({
  activeTimeInMilliseconds: 0,
  setActiveTimeInMilliseconds: () => {},
});
export default TimerContext;
